import { printHtml } from "@/components/inventory/shelfPrint";

const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const num = (n) => Math.round(n).toLocaleString();
const fmtQ = (n) => Number(Math.round(n * 100) / 100).toLocaleString();

const breakdown = (o) => {
  const bottles = Number(o.remaining_bottles) || 0;
  if (!bottles) return "—";
  const cp = Number(o.case_pack) || 0;
  const bpp = Number(o.bottles_per_pallet) || 0;
  const ppt = Number(o.pallets_per_truckload) || 0;
  const cases = cp ? bottles / cp : null;
  const pallets = bpp ? bottles / bpp : null;
  const trucks = ppt && pallets != null ? pallets / ppt : null;
  const top = [trucks != null ? `${fmtQ(trucks)} Truckload${trucks === 1 ? "" : "s"}` : null, pallets != null ? `${fmtQ(pallets)} Pallets` : null].filter(Boolean).join(" · ");
  const bottom = [cases != null ? `${fmtQ(cases)} Cases` : null, `${num(bottles)} Bottles`].filter(Boolean).join(" · ");
  return `${top ? `<span class="sub">${esc(top)}</span><br/>` : ""}${esc(bottom)}`;
};

// sections: [{title, stock, onOrder, reserved, orders:[{mo, production_date, product_name, design_name, case_pack, customer_name, remaining_bottles, bottles_per_pallet, pallets_per_truckload, reserved}]}]
export const printProductionReport = (sections) => {
  const body = sections.map((s) => `
    <div class="sec">
      <h2>${esc(s.title)}</h2>
      <div class="stats">
        ${[["On Order", s.onOrder], ["Units in Stock", s.stock], ["Reserved (Sales)", s.reservedSales ?? s.reserved], ["Reserved (Projections)", s.reservedProj ?? 0], ["Available After Sales", s.stock - (s.reservedSales ?? s.reserved)], ["Available After Projections", s.stock - s.reserved], ["Available After Purchases", s.stock + s.onOrder - s.reserved]]
          .map(([l, v]) => `<div class="stat"><span>${l}</span><b class="${v < 0 ? "neg" : ""}">${num(v)}</b></div>`).join("")}
      </div>
      ${s.orders.length ? `<table><thead><tr><th>MO</th><th>Prod. Date</th><th>Product / Design</th><th>Produce For</th><th>Remaining to Produce</th><th class="r">Reserved</th></tr></thead><tbody>
        ${[...s.orders].sort((a, b) => (a.projected ? 1 : 0) - (b.projected ? 1 : 0)).map((o) => `<tr><td class="b nw">${esc(o.mo)}${o.projected ? ' <span class="projtag">PROJECTED</span>' : ""}</td><td class="nw">${esc(o.production_date || "—")}</td><td>${esc(o.product_name || "—")}<br/><span class="sub">${esc([o.design_name, o.case_pack ? `${Math.round(o.case_pack)}pk` : null].filter(Boolean).join(" · ") || "—")}</span></td><td>${esc(o.customer_name || "—")}</td><td>${breakdown(o)}</td><td class="r b">${num(o.reserved)}</td></tr>`).join("")}
        <tr class="total"><td colspan="5">TOTAL RESERVED</td><td class="r b">${num(s.reserved)}</td></tr>
      </tbody></table>` : `<p class="none">No active production reservations.</p>`}
    </div>`).join("");
  const html = `<html><head><title>Inventory vs Production — ${esc(new Date().toLocaleDateString())}</title><style>
    * { box-sizing: border-box; margin: 0; }
    body { font-family: 'Helvetica Neue', Arial, sans-serif; color: #0f172a; padding: 0.35in; font-size: 11px; }
    h1 { font-size: 17px; }
    .meta { color: #64748b; font-size: 10px; margin: 2px 0 12px; }
    .sec { border: 1px solid #cbd5e1; padding: 10px 12px; margin-bottom: 12px; page-break-inside: avoid; }
    h2 { font-size: 13px; margin-bottom: 8px; }
    .stats { display: flex; gap: 8px; margin-bottom: 8px; }
    .stat { flex: 1; border: 1px solid #e2e8f0; padding: 4px 8px; }
    .stat span { display: block; font-size: 8px; text-transform: uppercase; letter-spacing: 0.08em; color: #64748b; font-weight: 700; }
    .stat b { font-size: 12px; }
    .neg { color: #dc2626; }
    table { width: 100%; border-collapse: collapse; }
    th { text-align: left; font-size: 8px; text-transform: uppercase; letter-spacing: 0.06em; color: #64748b; border-bottom: 1px solid #cbd5e1; padding: 3px 6px; }
    th.r { text-align: right; }
    td { border-bottom: 1px solid #e2e8f0; padding: 4px 6px; vertical-align: top; }
    .r { text-align: right; } .b { font-weight: 700; } .nw { white-space: nowrap; }
    .sub { color: #64748b; font-size: 9.5px; }
    .total td { border-bottom: none; font-size: 9px; font-weight: 700; padding-top: 6px; }
    .projtag { background: #fef3c7; color: #b45309; font-size: 7.5px; font-weight: 800; letter-spacing: 0.06em; padding: 1px 4px; border-radius: 6px; vertical-align: middle; }
    .none { color: #94a3b8; padding: 6px 0; }
    @page { size: letter portrait; margin: 0.3in; }
  </style></head><body>
    <h1>Inventory vs Production</h1>
    <p class="meta">Preforms · Caps · Labels · Trays — committed to active manufacturing orders. Generated ${esc(new Date().toLocaleString())}</p>
    ${body}
  </body></html>`;
  printHtml(html);
};
